﻿import React from 'react';
import {Grid} from "@mui/material";

type CardHeaderItemContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid item passthrough component. Used to hold HeaderTitleText and accompanying badges
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardHeaderItemContainer = ({ children, ...rest}: CardHeaderItemContainerProps) => {
  return <Grid item {...rest}>
    { children }
  </Grid>
}

export { CardHeaderItemContainer };
